import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ShareCardModal.css";

export default function AddHelperModal({
  isOpen,
  onClose,
  initialFullName = "",
  hasHelper = false,
}) {
  const [fullName, setFullName] = useState(initialFullName || "");
  const [isEditMode, setIsEditMode] = useState(hasHelper);
  const [cellular, setCellular] = useState("");
  const [email, setEmail] = useState("");
  const [connection, setConnection] = useState("");
  const [allowSee, setAllowSee] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  useEffect(() => {
    if (!isOpen) return;
    setAllowSee(true);
    setFullName(initialFullName || "");
    setIsEditMode(hasHelper);

    const loadData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/getMyHelper",
          config,
        );

        const helperData = response.data;

        if (helperData && helperData.length > 0) {
          setIsEditMode(true);
          setFullName(helperData[0].fullName || "");
          setCellular(helperData[0].cellular || "");
          setEmail(helperData[0].email || "");
          setConnection(helperData[0].connection || "");
          setAllowSee(helperData[0].allowSee == 1);
        } else {
          setIsEditMode(hasHelper);
          setFullName(initialFullName || "");
          setCellular("");
          setEmail("");
          setConnection("");
          setAllowSee(true);
        }
        setAllowSee(true);
        setIsDataLoaded(true);
      } catch (error) {
        setIsDataLoaded(true);
        alertUser("לא הצלחנו לטעון את פרטי הדאבליסט, אנא נסי שוב.");
      }
    };

    loadData();
  }, [isOpen, initialFullName, hasHelper]);

  const handleSubmit = async () => {
    setIsErrorMessageDisplayed(false);

    if (!fullNameValidator(fullName)) {
      alertUser("שם הדאבליסט לא תקין, אפשר עברית או אנגלית עד 45 תווים");
      return;
    }

    if (!phoneValidator(cellular)) {
      alertUser("מספר הטלפון של הדאבליסט לא תקין, המספר חייב להיות ישראלי");
      return;
    }

    if (!emailValidator(email)) {
      alertUser("המייל של הדאבליסט חסר או לא תקין");
      return;
    }

    if (connection === "") {
      alertUser("נא לבחור מה הקשר שלך לדאבליסט");
      return;
    }
    setIsLoading(true);

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/addOrUpdateMyHelper",
        {
          fullName: fullName.trim(),
          cellular: cleanPhone(cellular),
          email: email.trim(),
          con: connection,
          allowSee: allowSee ? 1 : 0,
        },
        config,
      );

      if (response.status === 200 && response.data?.success === true) {
        alertUser("הדאבליסט נשמר בהצלחה");

        setTimeout(() => {
          onClose();
          window.location.reload();
        }, 700);
      } else {
        alertUser("שגיאה בשמירה, נא לנסות שוב.");
      }
    } catch (error) {
      console.log("addOrUpdateMyHelper error:", error);

      if (error.response) {
        console.log("status:", error.response.status);
        console.log("data:", error.response.data);

        alertUser(
          error.response.data?.message ||
            `שגיאה מהשרת: ${error.response.status}`,
        );
      } else if (error.request) {
        console.log("request sent but no response:", error.request);
        alertUser("הבקשה נשלחה אבל לא התקבלה תשובה מהשרת");
      } else {
        console.log("error message:", error.message);
        alertUser("שגיאה לפני שליחת הבקשה לשרת");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fullNameValidator = (name) => {
    const regex = /^[\u05D0-\u05EAa-zA-Z ]+$/;
    return (
      name.trim().length >= 2 &&
      name.trim().length <= 45 &&
      regex.test(name.trim())
    );
  };

  const phoneValidator = (phoneNumber) => {
    const israelPhoneValidatorRegex =
      /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/i;

    return israelPhoneValidatorRegex.test(phoneNumber.trim());
  };

  const emailValidator = (email) => {
    const emailValidatorRegex =
      /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,})$/;

    return emailValidatorRegex.test(email.trim());
  };

  const cleanPhone = (phone) => {
    return phone.replace(/\D/g, "");
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {!isDataLoaded ? (
          <div>טוען...</div>
        ) : (
          <>
            <h3>
              {isEditMode ? "עריכת הדאבליסט המלווה שלי" : "הוספת דאבליסט מלווה"}
            </h3>

            {hasHelper && initialFullName && (
              <div style={{ marginBottom: "10px", fontWeight: "500" }}>
                הדאבליסט שלך היום הוא: <b>{initialFullName}</b>
              </div>
            )}
            <p>
              הדאבליסט הוא אדם קרוב שילווה אותך בתהליך, יוכל לצפות בפרופיל
              ובהתאמות שלך, ולעזור לך להתקדם בצורה רגועה ומדויקת.
            </p>

            <input
              type="text"
              className="freetext"
              style={{ height: "42px" }}
              placeholder="שם מלא של הדאבליסט"
              value={fullName}
              maxLength={45}
              autoComplete="off"
              onChange={(e) => setFullName(e.target.value)}
            />

            <input
              type="tel"
              className="freetext"
              style={{ height: "42px" }}
              placeholder="טלפון של הדאבליסט"
              value={cellular}
              maxLength={13}
              autoComplete="off"
              inputMode="tel"
              onChange={(e) => setCellular(e.target.value)}
            />

            <input
              type="email"
              className="freetext"
              style={{ height: "42px" }}
              placeholder="מייל של הדאבליסט"
              value={email}
              maxLength={100}
              autoComplete="off"
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="helper-relation-title">מה הקשר שלך לדאבליסט?</div>

            <div className="parent-edu">
              {[
                { value: "1", label: "משפחה" },
                { value: "2", label: "חבר/ה" },
                { value: "4", label: "שדכן/ית" },
                { value: "5", label: "מאמן/ת" },
              ].map((item) => (
                <button
                  type="button"
                  key={item.value}
                  className={
                    connection === item.value ? "region active" : "region"
                  }
                  onClick={() => setConnection(item.value)}
                >
                  {item.label}
                </button>
              ))}
            </div>

            <div className="checkbox-row">
              <input
                type="checkbox"
                checked={allowSee}
                onChange={(e) => setAllowSee(e.target.checked)}
              />
              <label>אני מאשר/ת לדאבליסט לצפות בפרופיל ובהתאמות שלי</label>
            </div>

            <div
              style={{
                fontSize: "0.85rem",
                color: "#777",
                marginTop: "6px",
                lineHeight: "1.4",
              }}
            >
              ניתן לשנות או להסיר את ההרשאה בכל שלב.
            </div>

            <div className="buttons">
              <button onClick={onClose}>ביטול</button>

              <button
                style={{
                  background: isLoading ? "#ccc" : "var(--btn-home-color)",
                }}
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "שומר..." : "שמירה"}
              </button>
            </div>

            {isErrorMessageDisplayed && (
              <div className="error-message">
                <h5>{errorMessage}</h5>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
